<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <NotificationDropDown class="nav-item--mobile"></NotificationDropDown>
        <sidebar-link to="/dashboard" name="Dashboard" icon="ti-dashboard" />
        <sidebar-link to="/sustainability/dashboard" name="Sustainability" icon="ti-pie-chart" />
        <sidebar-link to="/resiliency/dashboard" name="Resiliency" icon="ti-pulse" />
        <sidebar-link v-if="checkIfCanSeeConsumption()" to="/consumption" name="Consumption" icon="ti-stats-up" />
        <sidebar-link v-if="checkIfCanSeeSuggestion()" to="/suggestions" name="Suggestions" icon="ti-light-bulb" />
        <sidebar-link
          v-if="checkIfCanSeeQuestionnaire()"
          to="/manage_answers"
          name="Questionnaire"
          icon="ti-clipboard"
        />
        <sidebar-link
          v-else
          :to="{
            path: '/manage_answers/' + company.company_id,
            query: {
              company: company,
              selectedQuestionType: questionType,
            },
          }"
          name="Questionnaire"
          icon="ti-clipboard"
        />
        <sidebar-link
          v-if="checkIfCanSeeManageQuestions()"
          to="/manage_questions"
          name="Manage Questions"
          icon="ti-write"
        />
        <sidebar-link
          v-if="checkIfCanSeeCertificates()"
          to="/manage_certificates"
          name="Certificates"
          icon="fas fa-star"
        />
        <sidebar-link to="/settings" name="Settings" icon="ti-settings" />
        <sidebar-link to="/logout" name="Logout" icon="ti-shift-right" class="nav-item--mobile" @click="logout()" />
      </template>
      <mobile-menu> </mobile-menu>
    </side-bar>
    <div class="main-panel main-panel--withoutUpperSidebar">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './dashboard/TopNavbar';
import ContentFooter from './dashboard/ContentFooter.vue';
import DashboardContent from './dashboard/Content.vue';
import MobileMenu from './dashboard/MobileMenu';
import checkIfCanSeeSuggestion from '@/router/scopes/suggestions/CheckIfCanSeeSuggestion';
import checkIfCanSeeQuestionnaire from '@/router/scopes/questionnaire/CheckIfCanSeeQuestionnaire';
import checkIfCanSeeManageQuestions from '@/router/scopes/manage_questions/CheckIfCanSeeManageQuestions';
import checkIfCanSeeCertificates from '@/router/scopes/certificates/CheckIfCanSeeCertificates';
import NotificationDropDown from '@/components/Notifications/NotificationDropDown';
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';
export default {
  name: 'PageLayout',
  components: {
    NotificationDropDown,
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      questionType: null,
    };
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
  },
  async mounted() {
    await this.setQuestionType();
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    checkIfCanSeeSuggestion() {
      return checkIfCanSeeSuggestion();
    },
    checkIfCanSeeQuestionnaire() {
      return checkIfCanSeeQuestionnaire();
    },
    checkIfCanSeeManageQuestions() {
      return checkIfCanSeeManageQuestions();
    },
    checkIfCanSeeCertificates() {
      return checkIfCanSeeCertificates();
    },
    checkIfCanSeeConsumption() {
      return true;
    },
    logout() {
      this.$gtag.event('Logout', {
        method: 'Google',
      });
    },
    async setQuestionType() {
      let questionTypes = await QuestionTypeController.index();
      let questionType = questionTypes.find(function (questionType) {
        return questionType.name === 'SignUp';
      });
      this.questionType = questionType;
    },
  },
};
</script>

<style scoped></style>
